export const ROUTES = {
  about: '/about',
  contactUs: '/contactus',
  guarantee: '/guarantee',
  privacy: '/privacy',
  terms: '/terms',
  faq: '/faq',
  home: '/',
  search: '/search',
  search2: '/search-2',
  trademarkRegistration: '/trademark-registration',
  trademarkRegistrationFiling: '/trademark-registration-filing',
  comprehensiveSearch: '/comprehensive-search',
  comprehensiveSearchFiling: '/comprehensive-search-filing',
  statementOfUse: '/statement-of-use',
  statementOfUseFiling: '/statement-of-use-filing',
  trademarkMonitoring: '/trademark-monitoring',
  trademarkMonitoringFiling: '/trademark-monitoring-filing',
  officeActionResponse: '/office-action-response',
  officeActionResponseFiling: '/office-action-response-filing',
  renewal: '/renewal',
  renewalFiling: '/renewal-filing',
  requestForExtension: '/request-for-extension',
  requestForExtensionFiling: '/request-for-extension-filing',
  revivalFromAbandonment: '/revival-from-abandonment',
  revivalFromAbandonmentFiling: '/revival-from-abandonment-filing',
  logoDesignService: '/logo-design-service',
  logoDesignServiceFiling: '/logo-design-service-filing',
  payment: '/payment',
  upsell: '/upsell',
  thankyou: '/thankyou',
};
